import { AccountTreeOutlined, Download, PlayArrow } from '@mui/icons-material'
import { Box } from '@mui/material'
import clsx from 'clsx'
import IconButton from 'components/icon-button'
import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { useProject } from 'contexts/project'
import { IProjectRecipeDTO } from 'data/dtos/automation/i-project-dto'
import { useEffect, useState } from 'react'
import api from 'services/api'
import { dayjs } from 'utils/custom-date'
import donwloadFileWithAxiosResponse from 'utils/download-filte'
import ChipStatus from 'utils/project/chip-status'
import getDefinition from 'utils/project/definition'
import { isDisabledButtonPlayStatus } from 'utils/project/disabled-button-play-status'
import HandlerApp from './handler-app'
import { useStyles } from './styles'

interface ProjectWorkFlowViewProps {
  organizationId: string
  contractId: string
}

const ProjectWorkFlowView = ({ organizationId, contractId }: ProjectWorkFlowViewProps) => {
  const [timeSlots, setTimeSlots] = useState<Date[]>([])
  const { user } = useAuth()

  const { VITE_APP_AMBIENT } = import.meta.env

  const { data: project, refreshData: updateProject } = useProject()
  const { openAlert } = useAlert()

  const classes = useStyles()

  const generateTimeSlots = () => {
    const slots = []

    let currentTime = new Date()

    currentTime.setHours(currentTime.getHours() - 4)

    for (let i = 0; i < 6; i++) {
      slots.push(new Date(currentTime))
      currentTime.setMinutes(currentTime.getMinutes() + 10)
    }
    setTimeSlots(slots)
  }

  const handleFormatDate = (date: string | Date) => dayjs(date).format('DD/MM/YYYY - HH:mm:ss')

  const handleExecuteRecipe = async (position: number) => {
    try {
      await api.post(`/projects/trigger/${project.id}`, {
        position,
      })
      openAlert('Processo iniciado com sucesso', 'success')

      await updateProject()
    } catch (error) {
      console.log(error)
    }
  }

  const handleDownloadTemplate = async (id: string) => {
    try {
      const response = await api.get(`/apps/layouts/template/${project.id}`, {
        responseType: 'blob',
      })

      donwloadFileWithAxiosResponse(response)
      openAlert('Template baixado com sucesso', 'success')

      await updateProject()
    } catch (error) {
      console.log(error)
    }
  }

  const handleTranslateRecipeType = (type: string) => {
    switch (type) {
      case 'recipe':
        return 'Receita'
      case 'app':
        return 'App'
      default:
        return '-'
    }
  }

  const disabledRecipeInProduction = (recipe: IProjectRecipeDTO, name: string) => {
    if (VITE_APP_AMBIENT === 'prod') {
      if (recipe.appName === 'Editar Pessoas Jurídicas' || recipe.appId === '032d5221-7e51-4a59-a160-84d70a47d1eb') {
        return true
      }
    }

    if (recipe.appName === 'Multipla escolha') {
      return true
    }

    return false
  }

  useEffect(() => {
    generateTimeSlots()
  }, [])

  return (
    <Box className={classes.root}>
      <Box className={classes.headerLine}>
        <div className={classes.headerTitle}>
          <AccountTreeOutlined
            fontSize='medium'
            sx={{ opacity: 0.8 }}
          />
          <h1>Fluxo de Trabalho</h1>
        </div>
      </Box>

      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableNameSize}>Nome</th>
            <th className={classes.tableOthersSize}>Tipo</th>
            <th className={classes.tableOthersSize}>Última Atualização</th>
            <th className={classes.tableOthersSize}>Status</th>
            <th className={classes.tableInfoSize}></th>
            <th className={classes.tableActionSize}></th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          {project.recipes.map((recipe, index: number) => {
            const { recipeName, type, lastUpdate, status, position, appName, appDefinition } = recipe

            const isElegibleBase = project.name === 'Minha base elegivel' || project.name === 'Minha base elegível'

            const buttonPlayStatusIsDisabled = isDisabledButtonPlayStatus(recipe, project.recipes, index)

            // Pega o horário do array timeSlots pelo índice
            const displayDate = isElegibleBase ? timeSlots[index] : lastUpdate

            return (
              <tr key={Math.random()}>
                <td className={classes.tableNameSize}>
                  <span>{recipeName || appName}</span>
                </td>

                <td className={classes.tableOthersSize}>
                  <span>{handleTranslateRecipeType(type)}</span>
                </td>

                <td className={classes.tableOthersSize}>
                  {displayDate ? <span>{handleFormatDate(displayDate)}</span> : ''}
                </td>

                <td className={classes.tableOthersSize}>
                  <ChipStatus text={status as string} />
                </td>

                <td className={clsx(classes.tableInfoSize, classes.tableOpacityRecipeName)}>
                  {getDefinition(appDefinition)}
                </td>

                <td className={classes.tableActionSize}>
                  {type === 'recipe' && (
                    <IconButton
                      onClick={() => handleExecuteRecipe(position)}
                      // isDisabled={buttonPlayStatusIsDisabled}
                      tooltip='Iniciar Processo'
                      isDisabled={false}
                      icon={PlayArrow}
                    />
                  )}

                  {type === 'app' && (
                    <HandlerApp
                      id={recipe.id}
                      name={appName}
                      isDisabled={disabledRecipeInProduction(recipe, appName)}
                      definition={appDefinition}
                      organizationId={organizationId}
                      contractId={contractId}
                    />
                  )}

                  {type === 'template' && (
                    <IconButton
                      onClick={() => handleDownloadTemplate(recipe.appId)}
                      // isDisabled={buttonPlayStatusIsDisabled}
                      tooltip='Baixar Template'
                      isDisabled={false}
                      icon={Download}
                    />
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Box>
  )
}

export default ProjectWorkFlowView
